import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import DashboardWrapper from "../../components/DashboardWrapper";
import productService from "../../services/productService";
import Breadcrumb from "../../components/Breadcrumbdashboard";

export default function CreateBulkProducts() {
  const navigate = useNavigate();

  const [fileOne, setFileOne] = useState(null);
  const [fileTwo, setFileTwo] = useState(null);
  const [progress, setProgress] = useState(0);
  const [loading, setLoading] = useState(false);
  const fileOneRef = useRef(null);
  const fileTwoRef = useRef(null);
  const showAlert = (title, text, icon) => {
    Swal.fire({
      title,
      text,
      icon,
      confirmButtonText: "OK",
      buttonsStyling: false,
      customClass: {
        confirmButton: "btn btn-primary",
      },
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!fileOne || !fileTwo) {
      showAlert("Error", "Please select both files.", "error");
      return;
    }

    try {
      setLoading(true);
      setProgress(0);

      const formData = new FormData();
      formData.append("file", fileOne);
      formData.append("images_zip", fileTwo);

      const response = await productService.bulkImportProducts(
        formData,
        (progressEvent) => {
          if (progressEvent.total) {
            const percentCompleted = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            setProgress(percentCompleted);
          }
        }
      );
      setLoading(false);
      if (response?.data?.status) {
        showAlert("Success", response.data.message, "success");
        setFileOne(null);
        setFileTwo(null);
        setProgress(0);
        if (fileOneRef.current) fileOneRef.current.value = "";
        if (fileTwoRef.current) fileTwoRef.current.value = "";
      } else {
        showAlert(
          "Error",
          response?.data?.message || "Import failed",
          "error"
        );
      }
    } catch (error) {
      setLoading(false);
      console.log("FULL ERROR:", error);
      console.log("RESPONSE:", error?.response);
      if (error?.response?.status === 413) {
        showAlert("Error", "File size too large", "error");
      } else if (error?.response?.status === 401) {
        showAlert("Error", "Unauthorized. Please login again.", "error");
      } else {
        showAlert(
          "Error",
          error?.response?.data?.message || error.message,
          "error"
        );
      }
    }
  };
  return (
    <DashboardWrapper>
      <div className="p-4">
        <div className="d-flex justify-content-between align-items-center mb-4">
         <Breadcrumb/>
        </div>
        <div className="row">
          <div className="col-12">
            <div className="card">
              <h5 className="card-header">Create Bulk Product</h5>
              <div className="card-body">
                <form onSubmit={handleSubmit}>
                  <div className="mb-4">
                    <label className="form-label">
                      Upload File <span className="text-danger">*</span>
                    </label>
                    <input
                      type="file"
                      className="form-control"
                      ref={fileOneRef}
                      onChange={(e) => setFileOne(e.target.files[0])}
                    />
                  </div>
                  <div className="mb-4">
                    <label className="form-label">
                      Upload Images Zip <span className="text-danger">*</span>
                    </label>
                    <input
                      type="file"
                      className="form-control"
                      ref={fileTwoRef}
                      onChange={(e) => setFileTwo(e.target.files[0])}
                    />
                  </div>
                  {loading && (
                    <div className="mb-3">
                      <div className="progress">
                        <div
                          className="progress-bar progress-bar-striped progress-bar-animated"
                          role="progressbar"
                          style={{
                            width: `${progress}%`,
                            height: "13px",
                            fontWeight: "bold",
                            lineHeight: "13px",
                          }}
                        >
                          {progress}%
                        </div>
                      </div>
                    </div>
                  )}
                  <div className="mt-3">
                    <button
                      type="submit"
                      className="btn btn-primary"
                      disabled={loading}
                    >
                      {loading ? "Uploading..." : "Save"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

      </div>
    </DashboardWrapper>
  );
}


